module.exports = {
  i18n: {
    defaultLocale: 'en-US',
    locales: ['en-US', 'fil-PH', 'id-ID', 'ms-MY', 'th-TH', 'es-ES', 'ar-SA', 'zh-CN', 'zh-TW', 'vi-VN'],
  },
};
